import { inject, Injectable, signal } from '@angular/core';

import { AuthService, BREVO_HASH_UNRECOGNISED } from '~features/auth/auth.service';

export interface AutologinResult {
  success: boolean;
  hash: string;
  reason?: string;
}

@Injectable({
  providedIn: 'root',
})
export class BrevoAutoLoginService {
  private authService = inject(AuthService);

  // Use proper Angular signals for autologin results
  public autologinResult = signal<AutologinResult | null>(null);

  processNewsletterTracking(hash: string): void {
    try {
      if (!this.authService.isAuthenticated()) {
        this.autologinIfHashisValid(hash);
      }
    } catch (error) {
      console.log(error);
      // Set failed result due to error
      this.autologinResult.set({
        success: false,
        hash,
        reason: 'error',
      });
    }
  }

  /**
   * The hash is the credential: `POST /hubuser/loginwithbrevohash` looks the
   * account up and mints the session, rejecting when no account owns the hash.
   * There is no separate validity lookup first — `GET /users/hash/:hash` is
   * admin-only (#705), and it only ever repeated the login call's own verdict.
   */
  autologinIfHashisValid(hash: string) {
    this.authService.loginWithBrevoHash(hash).then(
      () => {
        this.autologinResult.set({
          success: true,
          hash,
        });
      },
      (error: unknown) => {
        this.autologinResult.set({
          success: false,
          hash,
          reason: error === BREVO_HASH_UNRECOGNISED ? 'invalid_hash' : 'http_error',
        });
      }
    );
  }
}
